import type { ThemeOptions } from '@mui/material'

export const typography: Partial<ThemeOptions['typography']> = {
  fontFamily: 'Circular, sans-serif;',
  button: {
    fontWeight: 600,
  },
}
